export const environment = {
  production: true,
  apiUrl: "https://stalcraft.trade/api",
  socketUrl: "wss://stalcraft.trade",
  publicAppUrl: "https://stalcraft.trade",
  discordClientID: "1186117798221598850",
  discordRedirectURI: "https://stalcraft.trade/code?type=discord",
  recaptchaSiteKey: "6Lcf_VoqAAAAAGN6ksVdX6Z2GAi7qTSLqIvYhI_5",
  exboClientID: "533",
  exboRedirectURI: "https://stalcraft.trade/code?type=exbo",
  vapidPublicKey: "BHzt0Hgg8K73YpN3purQyehP8Xi1iTCxs2PMCZswNNzZEmmjopZos6vwYtWDk5C7xJoExwpRNblDr38KCv9YH0g",
  discordUrl: "https://discord.gg/YGnhb2UD9E",
  cdnUrl: "https://stalcraft-wiki.storage.yandexcloud.net/exbo_item_parser/",
  sentryDSN: "https://16cc637daa7477e39753e8e539dfea77@sentry.igsteam.com/19",
  sentryEnabled: true,
  sentryRelease: "a61a34c91daadb7f8efe661d220ee99984097457"
};
